import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "m6 18 8.5-6L6 6v12zM16 6v12h2V6h-2z"
}), 'SkipNext');